import dayjs from 'dayjs'

export const getVersion = (date: Date) => {
  switch (true) {
    case dayjs(date).isBefore('2024-09-01'):
      return 0
    case dayjs(date).isBefore('2025-04-01'):
      return 1
    default:
      return 2
  }
}